import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from "react-select";

class FormCreate extends Component {

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered" backdrop={this.props.backdrop}>
                    <ModalHeader style={{ color: "#ffff", backgroundColor: this.props.getColorFactors(this.props.formValues.factor_type) }} toggle={this.props.toggle}><i className="app-menu__icon fa fa-user mr-2"></i> {this.props.formValues.factor_type}</ModalHeader>

                    <form onSubmit={this.handleSubmit}>
                        <ModalBody>
                            <div className="row">
                                {this.props.formValues.factor_type == 'Fortalezas' && (
                                    <div className="col-md-12">
                                        <label>Las {this.props.formValues.factor_type} son <b>factores internos</b> de su empresa o proyecto que ponen en <b>ventaja</b> respecto a su competencia.</label>
                                        <textarea
                                            name="description"
                                            value={this.props.formValues.description}
                                            onChange={this.props.onChangeForm}
                                            className={`form form-control ${this.props.ErrorValuesFortaleza == false && this.props.formValues.description == "" ? "error-class" : ""}`}
                                            rows="6"
                                        />
                                    </div>
                                )}

                                {this.props.formValues.factor_type == 'Debilidades' && (
                                    <div className="col-md-12">
                                        <label>Las {this.props.formValues.factor_type} son <b>factores internos</b> de su empresa o proyecto que pueden afectar <b>negativamente</b> el alcance de los objetivos</label>
                                        <textarea
                                            name="description"
                                            value={this.props.formValues.description}
                                            onChange={this.props.onChangeForm}
                                            className={`form form-control ${this.props.ErrorValuesFortaleza == false && this.props.formValues.description == "" ? "error-class" : ""}`}
                                            rows="6"
                                        />
                                    </div>
                                )}

                                {this.props.formValues.factor_type == 'Oportunidades' && (
                                    <div className="col-md-12">
                                        <label>Las {this.props.formValues.factor_type} son <b>factores externos</b> de su empresa o proyecto que <b>contribuye</b> al alcance de los objetivos</label>
                                        <textarea
                                            name="description"
                                            value={this.props.formValues.description}
                                            onChange={this.props.onChangeForm}
                                            className={`form form-control ${this.props.ErrorValuesFortaleza == false && this.props.formValues.description == "" ? "error-class" : ""}`}
                                            rows="6"
                                        />
                                    </div>
                                )}

                                {this.props.formValues.factor_type == 'Amenazas' && (
                                    <div className="col-md-12">
                                        <label>Las {this.props.formValues.factor_type} son <b>factores externos</b> de su empresa o proyecto que pueden afectar <b>negativamente</b> el alcance de los objetivos</label>
                                        <textarea
                                            name="description"
                                            value={this.props.formValues.description}
                                            onChange={this.props.onChangeForm}
                                            className={`form form-control ${this.props.ErrorValuesFortaleza == false && this.props.formValues.description == "" ? "error-class" : ""}`}
                                            rows="6"
                                        />
                                    </div>
                                )}






                                {this.props.ErrorValuesFortaleza == false && (
                                    <div className="col-md-12 mt-4">
                                        <div className="alert alert-danger" role="alert">
                                            <b>Debes de completar todos los campos requeridos</b>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <label className="btn btn-light mt-2" onClick={() => this.props.toggle()}>Cerrar</label>
                            <button className="btn-shadow btn"
                                onClick={this.props.submitForm}
                                style={{ color: "#ffff", backgroundColor: this.props.getColorFactors(this.props.formValues.factor_type) }}
                            >
                                {this.props.nameSubmit}
                            </button>
                        </ModalFooter>
                    </form>
                </Modal>
            </React.Fragment>
        );
    }
}

export default FormCreate;